import * as React from 'react';
import { ValidationError, getValidationErrorsForCollection } from '../../infrastructure/ValidationResult';
import { TextFormGroup } from '../../uiComponents/input/FormGroups';
import { Opgave } from '../../models/Opgave';
import { Form, Row, Col, Button } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { LinkSecondaryButton, AddContentButton } from '../../uiComponents/input/Buttons';
import { SectionGroup } from '../../uiComponents/layout/SectionGroup';
import { Section } from '../../uiComponents/layout/Section';
import { ButtonSection } from '../../uiComponents/layout/ButtonSection';
import { RouteComponentProps } from 'react-router';
import SubmitButton from '../../uiComponents/input/SubmitButton';
import { getBackendBaseUrl } from '../../infrastructure/BackendUrlResolver';
import { Link } from 'react-router-dom';
import FileInput, { RichTextFormGroup } from '../../uiComponents/input/FormGroups';
import { SectionDivider } from '../../uiComponents/layout/SectionDivider';
import OpgaveAfsnitComponent from './OpgaveAfsnitComponent';
import DelopgaveComponent from './DelopgaveComponent';
import { EditorState } from 'draft-js';
import { Clearfix } from '../../uiComponents/layout/Clearfix';

interface OpgaveEditProps extends RouteComponentProps<any> {
    opgave: Opgave;
    afsnitEditorStates: EditorState[];
    delopgaveEditorStates: EditorState[];
    opgaveEditorState: EditorState;
    errorMessages: ValidationError[];
    isNew: boolean;
    isSubmitting: boolean;
    onOpgaveSave: () => void;
    onOpgaveChanged: (fieldName: string, value: any) => void;
    onEditorChange: (editorState: EditorState) => void;
    addAfsnit: () => void;
    onAfsnitChanged: (fieldName: string, value: any, index: number) => void;
    onAfsnitEditorChanged: (editorState: EditorState, index: number) => void;
    removeAfsnit: (index: number) => void;
    addDelopgave: () => void;
    onDelopgaveChanged: (fieldName: string, value: any, index: number) => void;
    onDelopgaveResultatEnumChanged: (fieldName: string, value: any, index: number) => void;
    onDelopgaveEditorChanged: (editorState: EditorState, index: number) => void;
    removeDelopgave: (index: number) => void;
    addSpoergsmaal: (delopgaveIndex: number) => void;
    onSpoergsmaalChanged: (fieldName: string, value: any, index: number, delopgaveIndex: number) => void;
    removeSpoergsmaal: (index: number, delopgaveIndex: number) => void;
    addSvarmulighed: (delopgaveIndex: number, spoergsmaalIndex: number) => void;
    onSvarmulighedChanged: (fieldName: string, value: any, index: number, delopgaveIndex: number, spoergsmaalIndex: number) => void;
    removeSvarmulighed: (index: number, delopgaveIndex: number, spoergsmaalIndex: number) => void;
    onFileUpload: (formData: FormData) => void;
    removeBedoemmelsesFaktor: (index: number, delopgaveIndex: number) => void;
    addBedoemmelsesFaktor: (delopgaveIndex: number) => void;
    onBedoemmelsesFaktorChanged: (fieldName: string, value: any, index: number, delopgaveIndex: number) => void;
}
class OpgaveEdit extends React.Component<OpgaveEditProps, any> {
    constructor(props: OpgaveEditProps) {
        super(props);

        this.getAfsnit = this.getAfsnit.bind(this);
        this.getDelopgaver = this.getDelopgaver.bind(this);
    }

    getAfsnit() {
        if (this.props.opgave.opgaveAfsnit !== undefined) {
            return this.props.opgave.opgaveAfsnit.map((k, i) =>
                (
                    <OpgaveAfsnitComponent
                        opgaveAfsnit={k}
                        key={i}
                        index={i}
                        onAfsnitChanged={this.props.onAfsnitChanged}
                        errorMessages={this.props.errorMessages}
                        removeOpgaveAfsnit={this.props.removeAfsnit}
                        editorState={this.props.afsnitEditorStates[i]}
                        onEditorChange={this.props.onAfsnitEditorChanged}
                    />
                ));
        }

        return [];
    }

    getDelopgaver() {
        if (this.props.opgave.delopgaver !== undefined) {
            return this.props.opgave.delopgaver.map((k, i) => {
                let errors = getValidationErrorsForCollection(this.props.errorMessages, 'delopgaver', i);

                return (
                    <DelopgaveComponent
                        delopgave={k}
                        key={i}
                        index={i}
                        onDelopgaveChanged={this.props.onDelopgaveChanged}
                        onDelopgaveResultatEnumChanged={this.props.onDelopgaveResultatEnumChanged}
                        errorMessages={errors}
                        removeDelopgave={this.props.removeDelopgave}
                        editorState={this.props.delopgaveEditorStates[i]}
                        onEditorChange={this.props.onDelopgaveEditorChanged}
                        addSpoergsmaal={this.props.addSpoergsmaal}
                        onSpoergsmaalChanged={this.props.onSpoergsmaalChanged}
                        removeSpoergsmaal={this.props.removeSpoergsmaal}
                        addSvarmulighed={this.props.addSvarmulighed}
                        onSvarmulighedChanged={this.props.onSvarmulighedChanged}
                        removeSvarmulighed={this.props.removeSvarmulighed}
                        addBedoemmelsesFaktor={this.props.addBedoemmelsesFaktor}
                        removeBedoemmelsesFaktor={this.props.removeBedoemmelsesFaktor}
                        onBedoemmelsesFaktorChanged={this.props.onBedoemmelsesFaktorChanged}
                    />
                );
            });
        }

        return [];
    }

    render() {
        let title = this.props.isNew ? 'Opret opgave' : 'Redigér opgave';

        let imagePlaceholder = 'Vælg billede';
        let imageButtons = null;

        if (this.props.opgave.billedId !== undefined && this.props.opgave.billedId !== null) {
            let imageUrl = getBackendBaseUrl() + '/api/image/' + this.props.opgave.billedId;
            imagePlaceholder = 'Billede uploadet';
            imageButtons = (
                <Row>
                    <Col md={12}>
                        <ButtonSection noBorder={true}>
                            <Link to={imageUrl} target={'_blank'} className='btn btn-secondary'>Vis billede</Link>
                            <Button className='spacer' buttonType='secondary' onClick={() => this.props.onOpgaveChanged('billedId', undefined)}>Fjern billede</Button>
                        </ButtonSection>
                    </Col>
                </Row>
            );
        }

        return (
            <div>
                <SectionGroup header={title}>
                    <Form onSubmit={this.props.onOpgaveSave}>
                        <Section>
                            <Row>
                                <Col md={8} mdOffset={2}>
                                    <TextFormGroup
                                        errorMessages={this.props.errorMessages}
                                        label='Titel*'
                                        name='titel'
                                        placeholder='...'
                                        value={this.props.opgave.titel}
                                        onChange={this.props.onOpgaveChanged}
                                        autoFocus={true}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={8} mdOffset={2}>
                                    <FileInput
                                        errorMessages={this.props.errorMessages}
                                        label='Opgavebillede'
                                        name='billedId'
                                        placeholder={imagePlaceholder}
                                        onFileUpload={this.props.onFileUpload}
                                    />
                                </Col>
                            </Row>
                            {imageButtons}

                            <Row>
                                <Col md={8} mdOffset={2}>
                                    <RichTextFormGroup
                                        label='Oftest stillede spørgsmål'
                                        onEditorChange={(editorState: EditorState) => this.props.onEditorChange(editorState)}
                                        editorState={this.props.opgaveEditorState}
                                    />
                                </Col>
                            </Row>
                        </Section>

                        <SectionDivider />
                        {this.getAfsnit()}
                        <Section>
                            <Row>
                                <Col md={6} mdOffset={3}>
                                    <AddContentButton text={'Tilføj afsnit'} buttonOnClick={this.props.addAfsnit} />
                                </Col>
                            </Row>
                        </Section>
                        <SectionDivider />
                        <Col md={10} mdOffset={1}>
                            {this.getDelopgaver()}
                        </Col>
                        <Clearfix />

                        <Col md={10} mdOffset={1}>
                            <Section className='delopgave-tilfoej-delopgave-wrapper'>
                                <Row>
                                    <Col md={6} mdOffset={3}>
                                        <AddContentButton text={'Tilføj delopgave'} buttonOnClick={this.props.addDelopgave} />
                                    </Col>
                                </Row>
                            </Section>
                        </Col>
                        <Clearfix />

                        <ButtonSection validationErrors={this.props.errorMessages}>
                            <Row>
                                <Col md={6} mdOffset={3} className='center'>
                                    <LinkSecondaryButton className='spacer' url={'/opgaver'} text='Fortryd' />
                                    <SubmitButton isSubmitting={this.props.isSubmitting}>Gem opgave</SubmitButton>
                                </Col>
                                <Col md={3}>
                                    <LinkSecondaryButton url={'/opgave/preview/' + this.props.match.params.id} text='Forhåndsvisning' />                                    
                                </Col>
                            </Row>
                        </ButtonSection>
                    </Form>
                </SectionGroup>
            </div>
        );
    }
}

export default OpgaveEdit;


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/opgave/OpgaveEdit.tsx